<template>
  <div class="block" @click="foldClick">
    <div class="title">
      <span class="bar-item"></span>
      <span v-text="title" style="margin-left: 20px;"></span>
    </div>
    <img class="fold" v-show="fold" :src="src">
  </div>
</template>

<script>
  export default {
    name: 'Block',
    props: {
      title: String,
      fold: {
          type: Boolean,
          default: false
      }
    },
    data() {
        return {
            src: require('@/assets/fold-close.png'),
            isOpen: false
        }
    },
    methods: {
        foldClick() {
            if (this.isOpen) {
                this.isOpen = false
                this.src = require('@/assets/fold-close.png')
            } else {
                this.isOpen = true
                this.src = require('@/assets/fold-open.png')
            }
            this.$emit("on-fold", this.isOpen)
        }
    }
  }
</script>

<style lang="scss">
  .block {
    display: grid;
    grid-template-rows: 30px;
    grid-template-columns: 90% 10%;
    height: 42px;
    > .title {
      font-size: 16px;
      /*text-align: center;*/
      margin-top: 10px;
      grid-column: 1/2;
      .bar-item {
        position: absolute;
        background-color: #27B1F9;
        width: 5px;
        height: 25px;
        margin-left: 10px;
      }
    }
    .fold {
      position: absolute;
      right: 16px;
      margin-top: 10px;
      width: 25px;
    }
  }
</style>
